import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from 'components/Elements'; // or use your button
import { X } from 'lucide-react';

export const ExperimentalFeatureWarning = () => {
  const [visible, setVisible] = useState(true);

  // Prevent background scrolling when modal is visible
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 rounded-3xl bg-black/60 backdrop-blur-md flex items-center justify-center"
        >
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="relative w-full max-w-lg p-6 rounded-2xl shadow-xl bg-gradient-to-br from-blue-400/90 to-blue-600/60 dark:from-gray-900/60 dark:to-gray-800/30 border border-white/20 text-white"
          >
            <button
              onClick={() => setVisible(false)}
              className="absolute top-4 right-4 text-white hover:text-blue-200 transition"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="space-y-4 text-center mt-5">
              <h2 className="text-2xl font-bold">You're trying an Experimental Feature</h2>
              <p className="text-sm text-white/90">
                This part of the product is still under active development. While we’re excited for you to try it,
                some features may not behave as expected or could change without notice.
              </p>
              <p className="text-sm text-white/80">
                Please share feedback if you encounter anything unexpected, it helps us improve faster.
              </p>
              <Button variant="glass" onClick={() => setVisible(false)} className="mt-2 w-full">
                I Understand
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
